import React, { FC, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, fetchFormData, hasSpecialCharacters, isOnlyNumber, toasterrormsg, toastsuccessmsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { MixedWidget26 } from '../../../_metronic/partials/widgets'
import { CarRentalDetailsHeader } from './CarRentalDetailsHeader'
import Swal from 'sweetalert2'
import {useMediaReorder, ReorderButton, UploadedImageGrid, NewImageGrid} from '../mediaReorder'
import clsx from 'clsx'
import imageCompression from 'browser-image-compression';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import PriceInput from '../PriceInput'
import Select from 'react-select';
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'

const ViewCarsList: FC = () => {

  const t = Tr()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  const location = useLocation();
  const inputfileRef = useRef(null);
  const [loading, setLoading] = useState(false)
  const editCarrentalId = (location.state as any)?.carrentalId || '';
  // -------- state start ------------ 
  const [editVehicleId, setEditVehicleId] = useState("");
  const [tab, setTab] = useState('BasicInfo') // BasicInfo, Pricing, Policy, CarPhotos
  const [priceTab, setPriceTab] = useState('RegularPrice') // RegularPrice, SpecialPrice
  const [disable, setDisable] = useState(false);
  const [carRentalDetails, setCarRentalDetails] = useState([]);
  const [primLanguage, setPrimLanguage] = useState("");
  const [carNameEN, setCarNameEN] = useState("");
  const [carNameRU, setCarNameRU] = useState("");
  const [carNameUZ, setCarNameUZ] = useState("");
  const [baseCharge, setBaseCharge] = useState("");
  const [inputImage, setInputImage] = useState([]) as any;
  const [uploadedImage, setUploadedImage] = useState([]) as any;
  const reorder = useMediaReorder({
      type: 'vehicle',
      inputImage,
      setInputImage,
      uploadedImage,
      setUploadedImage,
  });
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayCarList, setDisplayCarList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  // ----------- state end ------------

  // handle modal show & hide
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false)
    setEditVehicleId("");
    cleanStates();
  };
  const handleShow = () => setShow(true);
  // car specs list state start
  const [carSpecsList, setCarSpecsList] = useState([]);
  const [carSpecsSelectedOptions, setCarSpecsSelectedOptions] = useState<any>([]);
  const carSpecsId = carSpecsSelectedOptions ? carSpecsSelectedOptions.map((option: any) => option.value).join(',') : "";
  // car specs list state end

  // car boot space list state start
  const [carBootSpaceList, setCarBootSpaceList] = useState([]);
  const [carBootSpaceSelectedOptions, setBootCarSpaceSelectedOptions] = useState<any>([]);
  const carBootSpaceId = carBootSpaceSelectedOptions ? carBootSpaceSelectedOptions.map((option: any) => option.value).join(',') : "";
  // car boot space list state end

  const [carCategoryList, setCarCategoryList] = useState([]);
  const [carCategorySelectedOptions, setCarCategorySelectedOptions] = useState<any>();
  const [carTypeList, setCarTypeList] = useState([]);
  const [carTypeSelectedOptions, setCarTypeSelectedOptions] = useState<any>();
  const [fuelPolicyList, setFuelPolicyList] = useState([]);
  const [fuelPolicySelectedOptions, setFuelPolicySelectedOptions] = useState<any>();
  const [mileageTypeList] = useState([
    { label: 'Per day', value: 'Per day' },
    { label: 'Per rental', value: 'Per rental' }
  ]);
  const [mileageTypeSelectedOptions, setMileageTypeSelectedOptions] = useState<any>();
  const [mileage, setMileage] = useState("");
  const [seatNumberList, setSeatNumberList] = useState([]);
  const [seatNumberSelectedOptions, setSeatNumberSelectedOptions] = useState<any>();
  const [gearShift, setGearShift] = useState("AUTOMATIC"); // AUTOMATIC, MANUAL
  const [ifExceedes, setIfExceedes] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [en_title, setEn_title] = useState("");
  const [ru_title, setRu_title] = useState("");
  const [uz_title, setUz_title] = useState("");
  const [mondayPrice, setMondayPrice] = useState("0");
  const [tuesdayPrice, setTuesdayPrice] = useState("0");
  const [wednesdayPrice, setWednesdayPrice] = useState("0");
  const [thursdayPrice, setThursdayPrice] = useState("0");
  const [fridayPrice, setFridayPrice] = useState("0");
  const [saturdayPrice, setSaturdayPrice] = useState("0");
  const [sundayPrice, setSundayPrice] = useState("0");
  const [specialPrice, setSpecialPrice] = useState([]) as any;
  const [editIndex, setEditIndex] = useState(-1);
  const [isUnlimited, setIsUnlimited] = useState(false);

  const handleIsUnlimited = (e: any) => {
    setIsUnlimited(e.target.checked); // Toggle the checked state
  };
  const [validationErrors, setValidationErrors] = useState([{
    en_title: '',
    ru_title: '',
    uz_title: '',
    fromDate: '',
    toDate: '',
    mondayPrice: '',
    tuesdayPrice: '',
    wednesdayPrice: '',
    thursdayPrice: '',
    fridayPrice: '',
    saturdayPrice: '',
    sundayPrice: '',
  }]);
  const [error, setError] = useState([{
    carNameEN: '',
    carNameRU: '',
    carNameUZ: '',
    carCategory: '',
    carType: '',
    fuelPolicy: '',
    carSpecsId: '',
    baseCharge: '',
    noOfSeats: '',
    carBootSpaceCapacityId: '',
    mileage: '',
    inputImage: '',
    mileageType: '',
  }])
  // ----------------------- functions ---------------------------- 
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = carRentalDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = carRentalDetails.slice(tmp, tolimi)
      setDisplayCarList(tmpdata)
    }

  }

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }

  const clearValidationError = (err: any) => {
    var tmp = [...validationErrors] as any;
    tmp[0][err] = "";
    setValidationErrors(tmp);
  };

  const formatDate = (date: any) => {
    return moment(date).format('DD-MM-YYYY h:mm A');
  };

  const validateSpecialPrice = () => {
    let isValid = true;
    const errorTmp = [...validationErrors];

    if (primLanguage === 'English') {
      if (!en_title.trim()) {
        errorTmp[0].en_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(en_title.trim())) {
        errorTmp[0].en_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    } else if (primLanguage === 'Russian') {
      if (!ru_title.trim()) {
        errorTmp[0].ru_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(ru_title.trim())) {
        errorTmp[0].ru_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    } else if (primLanguage === 'Uzbek') {
      if (!uz_title.trim()) {
        errorTmp[0].uz_title = t('Title Is Required');
        isValid = false;
      } else if (!hasSpecialCharacters(uz_title.trim())) {
        errorTmp[0].uz_title = t('Special Characters Are Not Allowed');
        isValid = false;
      }
    }

    if (!fromDate && fromDate != '0') {
      errorTmp[0].fromDate = t('Start Date Is Required.');
      isValid = false;
    }
    if (!toDate && toDate != '0') {
      errorTmp[0].toDate = t('End Date Is Required.');
      isValid = false;
    }
    if (!mondayPrice && mondayPrice != '0') {
      errorTmp[0].mondayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!tuesdayPrice && tuesdayPrice != '0') {
      errorTmp[0].tuesdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!wednesdayPrice && wednesdayPrice != '0') {
      errorTmp[0].wednesdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!thursdayPrice && thursdayPrice != '0') {
      errorTmp[0].thursdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!fridayPrice && fridayPrice != '0') {
      errorTmp[0].fridayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!saturdayPrice && saturdayPrice != '0') {
      errorTmp[0].saturdayPrice = t('Price Is Required.');
      isValid = false;
    }
    if (!sundayPrice && sundayPrice != '0') {
      errorTmp[0].sundayPrice = t('Price Is Required.');
      isValid = false;
    }

    setValidationErrors(errorTmp);
    return isValid;
  };
  const handleSave = () => {
    if (!validateSpecialPrice()) {
      return;
    }
    const newData = {
      fromDate,
      toDate,
      en_title,
      ru_title,
      uz_title,
      mondayPrice,
      tuesdayPrice,
      wednesdayPrice,
      thursdayPrice,
      fridayPrice,
      saturdayPrice,
      sundayPrice,
    };

    if (editIndex > -1) {
      const updatedData = specialPrice.map((item: any, index: any) => (index === editIndex ? newData : item));
      setSpecialPrice(updatedData);
      setEditIndex(-1);
    } else {
      setSpecialPrice([...specialPrice, newData]);
    }

    resetForm();
  };

  const handleEdit = (index: any) => {
    const item = specialPrice[index];
    setFromDate(item.fromDate);
    setToDate(item.toDate);
    setEn_title(item.en_title);
    setRu_title(item.ru_title);
    setUz_title(item.uz_title);
    setMondayPrice(item.mondayPrice);
    setTuesdayPrice(item.tuesdayPrice);
    setWednesdayPrice(item.wednesdayPrice);
    setThursdayPrice(item.thursdayPrice);
    setFridayPrice(item.fridayPrice);
    setSaturdayPrice(item.saturdayPrice);
    setSundayPrice(item.sundayPrice);
    setEditIndex(index);
  };

  const handleRemove = (index: any) => {
    setSpecialPrice(specialPrice.filter((_: any, i: any) => i !== index));
    resetForm();
  };

  const resetForm = () => {
    setFromDate('');
    setToDate('');
    setEn_title("");
    setRu_title("");
    setUz_title("");
    setMondayPrice("0");
    setTuesdayPrice("0");
    setWednesdayPrice("0");
    setThursdayPrice("0");
    setFridayPrice("0");
    setSaturdayPrice("0");
    setSundayPrice("0");
    setEditIndex(-1);
  };
  const handleImageChange = async (e: any) => {
    removeError("inputImage");
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((file: any) => {
      if (file.size > 5 * 1024 * 1024) { // 5 MB = 5 * 1024 * 1024 bytes
        toasterrormsg(`${file.name} ${t('is larger than 5 MB and was not added.')}`);
        return false;
      }
      return true;
    });
    const MAX_IMAGES = 15;
    // Check if adding selected files will exceed the limit
    if (inputImage.length + validFiles.length > MAX_IMAGES) {
      // If it exceeds, only select files up to the limit
      const remainingCapacity = MAX_IMAGES - inputImage.length;
      const limitedFiles = validFiles.slice(0, remainingCapacity);

      // Display a message or perform an action to notify the user about the limit
      toasterrormsg(t(`Maximum ${MAX_IMAGES} images can be uploaded.`));

      // Compress the images
      const processedFiles = await Promise.all(
        limitedFiles.map((file: any) => processImage(file))
      );

      // Store the processed file names as paths
      const filePaths = processedFiles.map((file) => file);

      // Append new images to the existing array of images
      setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
    } else {
      // If it doesn't exceed, proceed as before
      const processedFiles = await Promise.all(
        validFiles.map((file: any) => processImage(file))
      );
      const filePaths = processedFiles.map((file) => file);
      setInputImage((prevImages: any) => [...prevImages, ...filePaths]);
    }
  };

  const processImage = async (imageFile: File) => {
    if (imageFile.size >= 2 * 1024 * 1024) {
      return await compressImage(imageFile);
    } else {
      return imageFile;
    }
  };

  const compressImage = async (imageFile: File) => {
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1024,
      useWebWorker: true
    };
    try {
      const compressedBlob = await imageCompression(imageFile, options);
      const extension = imageFile.name.split('.').pop();
      const newFileName = `${Date.now()}.${extension}`;
      const compressedFile = new File([compressedBlob], newFileName, {
        type: compressedBlob.type,
        lastModified: Date.now()
      });
      return compressedFile;
    } catch (error) {
      console.error('Error compressing image:', error);
      return imageFile;
    }
  };

  // function for remove selected images
  const handleRemove1 = (index1: any) => {
    let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)
    setInputImage(tmparrimg);
  };

  // remove uplaoded images
  const handleRemoveImage = async (index: any) => {

    var param = {
      'carrentalmediaId': index
    }
    var res = await fetchData("public/deleteCarRentalMedia", param)

    if (res.status == "200") {
      carRentalDetailsApiCall()
    }
    else {
      toasterrormsg(res.message)
    }
  };

  const handleTextClick = () => {
    let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement;
    element.click();
  };

  // validation function
  const basicInfoValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (carSpecsSelectedOptions.length == 0) {
      errorTmp[0].carSpecsId = t('Car Specs Is Required');
      isValid = false;
    }
    if (carBootSpaceSelectedOptions.length == 0) {
      errorTmp[0].carBootSpaceCapacityId = t('Car Boot Space Is Required');
      isValid = false;
    }
    if (seatNumberSelectedOptions == "" || seatNumberSelectedOptions == null || seatNumberSelectedOptions == undefined) {
      errorTmp[0].noOfSeats = t('Seat Numbers Is Required');
      isValid = false;
    }
    if (carCategorySelectedOptions == "" || carCategorySelectedOptions == null || carCategorySelectedOptions == undefined) {
      errorTmp[0].carCategory = t('Car Category Is Required');
      isValid = false;
    }
    if (carTypeSelectedOptions == "" || carTypeSelectedOptions == null || carTypeSelectedOptions == undefined) {
      errorTmp[0].carType = t('Car Type Is Required');
      isValid = false;
    }
    if (fuelPolicySelectedOptions == "" || fuelPolicySelectedOptions == null || fuelPolicySelectedOptions == undefined) {
      errorTmp[0].fuelPolicy = t('Fuel Policy Is Required');
      isValid = false;
    }
    if (primLanguage == "English") {
      if (carNameEN.trim() == "" || carNameEN.trim() == null || carNameEN.trim() == undefined) {
        errorTmp[0].carNameEN = t('Car Name Is Required');
        isValid = false;
      }
    } else if (primLanguage == "Russian") {
      if (carNameRU.trim() == "" || carNameRU.trim() == null || carNameRU.trim() == undefined) {
        errorTmp[0].carNameRU = t('Car Name Is Required');
        isValid = false;
      }
    } else if (primLanguage == "Uzbek") {
      if (carNameUZ.trim() == "" || carNameUZ.trim() == null || carNameUZ.trim() == undefined) {
        errorTmp[0].carNameUZ = t('Car Name Is Required');
        isValid = false;
      }
    }

    setError(errorTmp);
    return isValid;
  }
  const pricingValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (baseCharge == "" || baseCharge == null || baseCharge == undefined) {
      errorTmp[0].baseCharge = t('Car Price Is Required');
      isValid = false;
    } else if (!isOnlyNumber(baseCharge)) {
      errorTmp[0].baseCharge = t('Only Number Is Allowed');
      isValid = false;
    }

    setError(errorTmp);
    return isValid;
  }
  const policyValidate = () => {
    var isValid = true;
    var errorTmp = [...error];

    if (!isUnlimited) {
      if (mileageTypeSelectedOptions == "" || mileageTypeSelectedOptions == null || mileageTypeSelectedOptions == undefined) {
        errorTmp[0].mileageType = t('Mileage Type Is Required');
        isValid = false;
      }
      if (mileage == "" || mileage == null || mileage == undefined) {
        errorTmp[0].mileage = t('Mileage Is Required');
        isValid = false;
      } else if (!isOnlyNumber(mileage)) {
        errorTmp[0].mileage = t('Only Number Is Allowed');
        isValid = false;
      }
    }

    setError(errorTmp);
    return isValid;
  }
  const carPhotosvalidate = () => {

    var isValid = true;
    var errorTmp = [...error];

    if (uploadedImage.length < 2) {

      if (inputImage.length == 0) {
        errorTmp[0].inputImage = t('Car Images Is Required');
        isValid = false;
      } else if (inputImage.length < 2) {
        errorTmp[0].inputImage = t('Minimum 3 Images Is Required');
        isValid = false;
      }
    }

    setError(errorTmp);
    return isValid;
  }

  const handleTabChange = (nextTab: any) => {
    let isValid = true;

    if (isNextTab(nextTab)) {
      switch (tab) {
        case 'BasicInfo':
          isValid = basicInfoValidate();
          break;
        case 'Pricing':
          isValid = pricingValidate();
          break;
        case 'Policy':
          isValid = policyValidate();
          break;
        case 'CarPhotos':
          isValid = carPhotosvalidate();
          break;
        default:
          break;
      }
    }

    if (isValid) {
      setTab(nextTab);
    }
  }
  const isNextTab = (nextTab: any) => {
    const tabOrder = ['BasicInfo', 'Pricing', 'Policy', 'CarPhotos'];
    return tabOrder.indexOf(nextTab) > tabOrder.indexOf(tab);
  }
  const nextToCarsPolicy = () => {
    handleTabChange('Policy');
  }
  const nextToCarsPricing = () => {
    handleTabChange('Pricing');
  }
  const nextToCarsPhotos = () => {
    handleTabChange('CarPhotos');
  }

  // ------------------------------------- apis call ------------------------------------
  // hotel Details api call
  const carRentalDetailsApiCall = async () => {

    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData("public/carRentalDetail", param)

    if (response.status == "200") {
      var carList = response.data[0]['vehcileDetail'];
      setCarRentalDetails(carList);
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = carList.slice(offset, offset + limit);
      setDisplayCarList(tmp)
      var totpag = (Math.ceil(carList.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = carList.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = carList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
      if (editVehicleId != "") {

        var vehicle = carList.find((value: any) => value['vehicleId'] === editVehicleId);

        setCarNameEN(vehicle['en_name'])
        setCarNameRU(vehicle['ru_name'])
        setCarNameUZ(vehicle['uz_name'])
        var carCategory: any = []
        vehicle.carCategory.map((val: any) => {
          carCategory.push({ value: val.carcategoryId, label: val.en_name })
        })
        setCarCategorySelectedOptions(carCategory[0])
        var carType: any = []
        vehicle.carType.map((val: any) => {
          carType.push({ value: val.cartypeId, label: val.en_name })
        })
        setCarTypeSelectedOptions(carType[0])
        var carSpecs: any = []
        vehicle.specs.map((val: any) => {
          carSpecs.push({ value: val.specsId, label: val.en_name })
        })
        setCarSpecsSelectedOptions(carSpecs)
        var fuelPolicy: any = []
        vehicle.fuelPolicy.map((val: any) => {
          fuelPolicy.push({ value: val.fuelpolicyId, label: val.en_name })
        })
        setFuelPolicySelectedOptions(fuelPolicy[0])
        var carbootspace: any = []
        vehicle.carbootspace.map((val: any) => {
          carbootspace.push({ value: val.carbootspaceId, label: val.en_name })
        })
        setBootCarSpaceSelectedOptions(carbootspace)
        setBaseCharge(vehicle['price'] + '')

        var seatNumber: any = []
        vehicle.seatsDetail.map((val: any) => {
          seatNumber.push({ value: val.seatnumberId, label: val.seats })
        })
        setSeatNumberSelectedOptions(seatNumber[0] ? seatNumber[0] : [])
        setGearShift(vehicle['gear_shift'])
        setUploadedImage(vehicle['images'])
        setIsUnlimited(vehicle['isUnlimited'] && vehicle['isUnlimited'] == '1' ? true : false)

        if (vehicle['isUnlimited'] != '1') {
          setMileageTypeSelectedOptions({ label: vehicle['mileageType'], value: vehicle['mileageType'] })
          setMileage(vehicle['mileage'])
          setIfExceedes(vehicle['ifExceedes'])
        }
        if (vehicle['specialPriceDetail'].length > 0) {
          setSpecialPrice(vehicle['specialPriceDetail'])
        }
      }
    }
    else {
      toasterrormsg(response.message)
    }
  }
  const carspecsListAPIcall = async () => {

    var res = await fetchData("public/specsList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.specsId, label: val.en_name })
      })
      setCarSpecsList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  const carBootSpaceListAPIcall = async () => {

    var res = await fetchData("public/carBootSpaceList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.carbootspaceId, label: val.en_name })
      })
      setCarBootSpaceList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  const carCategoryListAPIcall = async () => {

    var res = await fetchData("public/carCategoryList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.carcategoryId, label: val.en_name })
      })
      setCarCategoryList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  const seatNumberListAPIcall = async () => {

    var res = await fetchData("public/seatnumberList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.seatnumberId, label: val.seats })
      })
      setSeatNumberList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  const carTypeListAPIcall = async () => {

    var res = await fetchData("public/carTypeList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.cartypeId, label: val.en_name })
      })
      setCarTypeList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  const fuelPolicyListAPIcall = async () => {

    var res = await fetchData("public/fuelPolicyList", {})

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.fuelpolicyId, label: val.en_name })
      })
      setFuelPolicyList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  // add api call
  const addCarsApi = async () => {
    if (carPhotosvalidate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('carrentalId', editCarrentalId)
      param.append('en_name', carNameEN)
      param.append('ru_name', carNameRU)
      param.append('uz_name', carNameUZ)
      param.append('carcategoryId', carCategorySelectedOptions.value)
      param.append('cartypeId', carTypeSelectedOptions.value)
      param.append('specsId', carSpecsId)
      param.append('fuelpolicyId', fuelPolicySelectedOptions.value)
      param.append('price', baseCharge)
      param.append('seats', seatNumberSelectedOptions.value)
      param.append('gear_shift', gearShift)
      param.append('carbootspaceId', carBootSpaceId)
      param.append('isUnlimited', isUnlimited ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (!isUnlimited) {
        param.append('mileageType', mileageTypeSelectedOptions.value)
        param.append('mileage', mileage)
        param.append('ifExceedes', ifExceedes)
      }

      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file);
        });
      }

      var res = await fetchFormData("public/addVehicle", param)

      if (res.status == "200") {
        toastsuccessmsg(t('Car Added Successfully!'))
        carRentalDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false);

      }
      else {
        setLoading(false);
        toasterrormsg(res.message)
        setDisable(false)

      }
    }
  }
  //   delete api call
  const confirmdelete = (vehicleId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'vehicleId': vehicleId
        }
        var res = await fetchData("public/deleteVehicle", param)

        if (res.status == "200") {
          carRentalDetailsApiCall();
        }
        else {
          toasterrormsg(res.message)

        }
      }
    });
  }
  const editModalOpen = (vehicleId: any) => {
    setEditVehicleId(vehicleId);
    handleShow()
  }
  useEffect(() => {
    carRentalDetailsApiCall();
  }, [editVehicleId])
  // edit api call
  const editCarsApi = async () => {
    if (carPhotosvalidate()) {

      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('carrentalId', String(editCarrentalId))
      param.append('vehicleId', String(editVehicleId))
      param.append('en_name', carNameEN)
      param.append('ru_name', carNameRU)
      param.append('uz_name', carNameUZ)
      param.append('carcategoryId', carCategorySelectedOptions.value)
      param.append('cartypeId', carTypeSelectedOptions.value)
      param.append('specsId', carSpecsId)
      param.append('fuelpolicyId', fuelPolicySelectedOptions.value)
      param.append('price', baseCharge)
      param.append('seats', seatNumberSelectedOptions.value)
      param.append('gear_shift', gearShift)
      param.append('carbootspaceId', carBootSpaceId)
      param.append('isUnlimited', isUnlimited ? '1' : '0')
      param.append('specialPrice', JSON.stringify(specialPrice))
      if (!isUnlimited) {
        param.append('mileageType', mileageTypeSelectedOptions.value)
        param.append('mileage', mileage)
        param.append('ifExceedes', ifExceedes)
      }
      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file);
        });
      }

      var res = await fetchFormData("public/addVehicle", param)

      if (res.status == "200") {
        toastsuccessmsg(t("Car Saved Successfully!"))
        carRentalDetailsApiCall()
        handleClose()
        cleanStates()
        setDisable(false)
        setLoading(false);

      }
      else {
        setLoading(false);
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
    setDisable(false)

  }

  useEffect(() => {
    carspecsListAPIcall()
    carCategoryListAPIcall()
    carBootSpaceListAPIcall()
    carTypeListAPIcall()
    fuelPolicyListAPIcall()
    seatNumberListAPIcall()
  }, [])
  const cleanStates = () => {
    setLoading(false);
    setCarNameEN("");
    setCarNameRU("");
    setCarNameUZ("");
    setCarCategorySelectedOptions(undefined);
    setCarTypeSelectedOptions(undefined);
    setCarSpecsSelectedOptions([]);
    setFuelPolicySelectedOptions(undefined);
    setMileageTypeSelectedOptions(undefined);
    setIfExceedes("");
    setMileage("");
    setBaseCharge("");
    setSeatNumberSelectedOptions(undefined);
    setGearShift("AUTOMATIC")
    setTab("BasicInfo");
    setInputImage([]);
    setUploadedImage([]);
    removeError("carNameEN");
    removeError("carNameRU");
    removeError("carNameUZ");
    removeError("baseCharge");
    removeError("inputImage");
    removeError("carCategory");
    removeError("carType");
    removeError("fuelPolicy");
    removeError("carSpecsId");
    removeError("noOfSeats");
    removeError("noOfSmallBeg");
    removeError("noOfLargeBeg");
    removeError("mileage");
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Cars')}</PageTitle>
      <ToastContainer />
      <CarRentalDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {
          displayCarList.map((car: any, index: any) => {
            var description = "";
            var vehicleName = "";
            if (primLanguage == "English") {
              // description = car['en_description'];
              vehicleName = car['en_name'];
            } else if (primLanguage == "Russian") {
              // description = car['ru_description'];
              vehicleName = car['ru_name'];
            } else if (primLanguage == "Uzbek") {
              // description = car['uz_description'];
              vehicleName = car['uz_name'];
            }
            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget26
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  vehicleId={car['vehicleId']}
                  deleteCar={confirmdelete}
                  editModalOpen={editModalOpen}
                  vehicleName={vehicleName}
                  image={(car['images'].length != 0) ? car['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                  carCategory={car['carCategory'].length != 0 ? car['carCategory'][0]['en_name'] : ''}
                  mileage={car['mileage']}
                  maxPeople={car['seats']}
                  progress='100%'
                />
              </div>
            )
          })
        }
      </div>
      {
        carRentalDetails.length != 0 ? (
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>{t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(carRentalDetails.length))}</div>
            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any, index: any) => {
                return (
                  <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`} key={index}>
                    <span className='page-link' onClick={() => onpagecahnge(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        ) : ('')
      }
      {/* end::Row */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal fade show" id="kt_modal_upload" tabIndex={-1} style={{ display: "block" }} aria-modal="true" role="dialog">
          {/* <!--begin::Modal dialog--> */}
          <div className="modal-dialog modal-dialog-centered mw-950px">
            {/* <!--begin::Modal content--> */}
            <div className="modal-content">
              {/* <!--begin::Form--> */}
              <div className="form" id="kt_modal_upload_form">
                {/* <!--begin::Modal header--> */}
                <div className="modal-header d-flex justify-content-between">
                  {/* <!--begin::Modal title--> */}
                  <h2 className="fw-bold"> {editVehicleId != "" ? t('Edit Cars') : t('Add Cars')}</h2>
                  {/* <!--end::Modal title--> */}
                  {/* <!--begin::Close--> */}
                  <div className="btn btn-icon btn-sm btn-active-icon-primary" onClick={handleClose}>
                    <i className="ki-duotone ki-cross fs-1"><span className="path1"></span><span className="path2"></span></i>
                  </div>
                  {/* <!--end::Close--> */}
                </div>
                <div className='card card-custom'>
                  <div className='card-header card-header-stretch overflow-auto'>
                    <ul
                      className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                      role='tablist'
                    >
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'BasicInfo' })}
                          onClick={() => setTab('BasicInfo')}
                          role='tab'
                        >
                          {t('Basic Info')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'Pricing' })}
                          onClick={nextToCarsPricing}
                          role='tab'
                        >
                          {t('Pricing')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'Policy' })}
                          onClick={nextToCarsPolicy}
                          role='tab'
                        >
                          {t('Policy')}
                        </a>
                      </li>
                      <li className='nav-item'>
                        <a
                          className={clsx(`nav-link cursor-pointer`, { active: tab === 'CarPhotos' })}
                          onClick={nextToCarsPhotos}
                          role='tab'
                        >
                          {t('Car Photos')}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <!--end::Modal header--> */}
                {/* <!--begin::Modal body--> */}
                <div className="modal-body pt-10 pb-15 px-lg-17">
                  {/* <!--begin::Input group--> */}
                  <div className="form-group">
                    {/* <!--begin::Dropzone--> */}
                    <div className="dropzone dropzone-queue mb-2" id="kt_modal_upload_dropzone">
                      {/* <!--begin::Controls--> */}
                      <div className="dropzone-panel mb-4">
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'BasicInfo' })}>
                            {
                              primLanguage == "English" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Car Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameEN" className="form-control mb-2" placeholder={t("Car Name")} value={carNameEN} onChange={(e) => { setCarNameEN(e.target.value); removeError("carNameEN"); }} />
                                      <div className='text-danger fw-bold'>{error[0].carNameEN}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Car Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameRU" className="form-control mb-2" placeholder={t("Car Name")} value={carNameRU} onChange={(e) => { setCarNameRU(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Car Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameUZ" className="form-control mb-2" placeholder={t("Car Name")} value={carNameUZ} onChange={(e) => { setCarNameUZ(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primLanguage == "Russian" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Car Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameRU" className="form-control mb-2" placeholder={t("Car Name")} value={carNameRU} onChange={(e) => { setCarNameRU(e.target.value); removeError("carNameRU"); }} />
                                      <div className='text-danger fw-bold'>{error[0].carNameRU}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Car Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameEN" className="form-control mb-2" placeholder={t("Car Name")} value={carNameEN} onChange={(e) => { setCarNameEN(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="fs-5 form-label">{t('Car Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameUZ" className="form-control mb-2" placeholder={t("Car Name")} value={carNameUZ} onChange={(e) => { setCarNameUZ(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              primLanguage == "Uzbek" && (
                                <>
                                  <div className="row">
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className="required fs-5 form-label">{t('Car Name (Uzbek)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameUZ" className="form-control mb-2" placeholder={t("Car Name")} value={carNameUZ} onChange={(e) => { setCarNameUZ(e.target.value); removeError("carNameUZ"); }} />
                                      <div className='text-danger fw-bold'>{error[0].carNameUZ}</div>
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Car Name (Russian)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameRU" className="form-control mb-2" placeholder={t("Car Name")} value={carNameRU} onChange={(e) => { setCarNameRU(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                    <div className="col-lg-4 my-3">
                                      {/* <!--begin::Label--> */}
                                      <label className=" fs-5 form-label">{t('Car Name (English)')}</label>
                                      {/* <!--end::Label--> */}
                                      {/* <!--begin::Input--> */}
                                      <input type="text" name="carNameEN" className="form-control mb-2" placeholder={t("Car Name")} value={carNameEN} onChange={(e) => { setCarNameEN(e.target.value) }} />
                                      {/* <!--end::Input--> */}
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            <div className="row">
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="fs-4 form-label required">{t('Car Category')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='carCategory[]'
                                  id='carCategory'
                                  placeholder={t('Select Car Category')}
                                  isSearchable={true}
                                  options={carCategoryList}
                                  value={carCategorySelectedOptions}
                                  onChange={(e: any) => { setCarCategorySelectedOptions(e); removeError("carCategory") }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].carCategory}</div>
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="fs-4 form-label required">{t('Car Type')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='carType[]'
                                  id='carType'
                                  placeholder={t('Select Car Type')}
                                  isSearchable={true}
                                  options={carTypeList}
                                  value={carTypeSelectedOptions}
                                  onChange={(e: any) => { setCarTypeSelectedOptions(e); removeError("carType") }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].carType}</div>
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-4 form-label">{t('Car Specs')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='carSpecs[]'
                                  id='carSpecsId'
                                  placeholder={t('Select Car Specs')}
                                  isSearchable={true}
                                  isMulti
                                  options={carSpecsList}
                                  value={carSpecsSelectedOptions}
                                  onChange={(e: any) => { setCarSpecsSelectedOptions(e); removeError("carSpecsId"); }}

                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].carSpecsId}</div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="fs-4 form-label required">{t('Fuel Policy')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='fuelPolicy[]'
                                  id='fuelPolicy'
                                  placeholder={t('Select Fuel Policy')}
                                  isSearchable={true}
                                  options={fuelPolicyList}
                                  value={fuelPolicySelectedOptions}
                                  onChange={(e: any) => { setFuelPolicySelectedOptions(e); removeError("fuelPolicy") }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].fuelPolicy}</div>
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-4 form-label">{t('Number Of Seats')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='noOfSeats[]'
                                  id='noOfSeats'
                                  placeholder={t('Select Number Of Seats')}
                                  isSearchable={true}
                                  options={seatNumberList}
                                  value={seatNumberSelectedOptions}
                                  onChange={(e: any) => { setSeatNumberSelectedOptions(e); removeError("noOfSeats") }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].noOfSeats}</div>
                              </div>
                              <div className="col-lg-4 my-3">
                                {/* <!--begin::Label--> */}
                                <label className="required fs-4 form-label">{t('Car Boot Space Capacity')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <Select
                                  name='carBootSpaceCapacity[]'
                                  id='carBootSpaceCapacityId'
                                  placeholder={t('Select Car Boot Space Capacity')}
                                  isSearchable={true}
                                  isMulti
                                  options={carBootSpaceList}
                                  value={carBootSpaceSelectedOptions}
                                  onChange={(e: any) => { setBootCarSpaceSelectedOptions(e); removeError("carBootSpaceCapacityId"); }}

                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].carBootSpaceCapacityId}</div>
                              </div>
                              <div className="col-lg-4 col-5 my-3">
                                <label className="fs-4 form-label required">{t('Gear Shift')}</label>
                                <div className="d-flex justify-content-between my-2">
                                  <label className="d-flex text-start" data-kt-button="true">
                                    {/* <!--begin::Radio--> */}
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                      <input className="form-check-input" type="radio" name="gearShift" value="AUTOMATIC" checked={gearShift == "AUTOMATIC"} onChange={(e: any) => { setGearShift(e.target.value) }} />
                                    </span>
                                    {/* <!--end::Radio--> */}

                                    {/* <!--begin::Info--> */}
                                    <span className="ms-5">
                                      <span className="fs-4 fw-bold text-gray-800 d-block">{t('Automatic')}</span>
                                    </span>
                                    {/* <!--end::Info--> */}
                                  </label>
                                  <label className="d-flex text-start" data-kt-button="true">
                                    {/* <!--begin::Radio--> */}
                                    <span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
                                      <input className="form-check-input" type="radio" name="gearShift" value="MANUAL" checked={gearShift == "MANUAL"} onChange={(e: any) => { setGearShift(e.target.value) }} />
                                    </span>
                                    {/* <!--end::Radio--> */}

                                    {/* <!--begin::Info--> */}
                                    <span className="ms-5">
                                      <span className="fs-4 fw-bold text-gray-800 d-block">{t('Manual')}</span>
                                    </span>
                                    {/* <!--end::Info--> */}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12 mt-5">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={handleClose}>{t('Cancel')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToCarsPricing}>
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', { active: tab === 'Pricing' })}>
                            <div className='card-header card-header-stretch overflow-auto'>
                              <ul
                                className='nav nav-stretch nav-line-tabs fw-semibold border-transparent flex-nowrap'
                                role='tablist'
                              >
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, { active: priceTab === 'RegularPrice' })}
                                    onClick={() => setPriceTab('RegularPrice')}
                                    role='tab'
                                  >
                                    {t('Regular Price')}
                                  </a>
                                </li>
                                <li className='nav-item'>
                                  <a
                                    className={clsx(`nav-link cursor-pointer`, { active: priceTab === 'SpecialPrice' })}
                                    onClick={() => setPriceTab('SpecialPrice')}
                                    role='tab'
                                  >
                                    {t('Special Price')}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className='tab-content pt-3'>
                              <div className={clsx('tab-pane', { active: priceTab === 'RegularPrice' })}>
                                <div className="row">
                                  <div className="col-lg-4 my-3">
                                    <PriceInput
                                      labelClass="required fs-5 form-label"
                                      label={t("Car Price (By Day)")}
                                      inputClass="form-control mb-2 border-right-0"
                                      placeholder={t("Car Price")}
                                      value={baseCharge}
                                      onChange={(e: any) => { setBaseCharge(e); removeError("baseCharge"); }}
                                    />
                                    <div className='text-danger fw-bold'>{error[0].baseCharge}</div>
                                  </div>
                                </div>
                              </div>
                              <div className={clsx('tab-pane', { active: priceTab === 'SpecialPrice' })}>
                                <div className="col-lg-12 d-flex bg-light-warning p-3 border rounded border-warning">
                                  <span className='fs-3 text-gray-500 required'></span> <label className="fs-7 text-gray-600 form-label"> {t('Fill out this section only if you want to set “Special Prices” for your services. Otherwise, simply skip it. Special Prices are typically offered to customers during holidays and special days at your discretion.')}</label>
                                </div>
                                <div className="row mt-5">
                                  <div className="col-lg-12">
                                    <label className="fs-4 fw-bolder form-label">{t('Date Range')}</label>
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-5 required form-label">{t('From')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={fromDate}
                                      onChange={([date]) => {
                                        setFromDate(date.toISOString()); clearValidationError('fromDate');
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i"
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].fromDate}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-5 required form-label">{t('To')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Flatpickr
                                      value={toDate}
                                      onChange={([date]) => {
                                        setToDate(date.toISOString()); clearValidationError('toDate');
                                      }}
                                      options={{
                                        enableTime: true,
                                        dateFormat: "Y-m-d H:i"
                                      }}
                                      className='form-control mb-2'
                                      placeholder={t('Date')}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].toDate}</div>
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                                {
                                  primLanguage == "English" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); clearValidationError("en_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].en_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                {
                                  primLanguage == "Russian" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); clearValidationError("ru_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].ru_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                {
                                  primLanguage == "Uzbek" && (
                                    <div className="row">
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="required fs-5 form-label">{t('Title (Uzbek)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="uz_title" className="form-control mb-2" placeholder={t("Title")} value={uz_title} onChange={(e) => { setUz_title(e.target.value); clearValidationError("uz_title"); }} />
                                        <div className='text-danger fw-bold'>{validationErrors[0].uz_title}</div>
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (Russian)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="ru_title" className="form-control mb-2" placeholder={t("Title")} value={ru_title} onChange={(e) => { setRu_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                      <div className="col-lg-4 my-3">
                                        {/* <!--begin::Label--> */}
                                        <label className="fs-5 form-label">{t('Title (English)')}</label>
                                        {/* <!--end::Label--> */}
                                        {/* <!--begin::Input--> */}
                                        <input type="text" name="en_title" className="form-control mb-2" placeholder={t("Title")} value={en_title} onChange={(e) => { setEn_title(e.target.value); }} />
                                        {/* <!--end::Input--> */}
                                      </div>
                                    </div>
                                  )
                                }
                                <div className="row">
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Monday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={mondayPrice}
                                      onChange={(e: any) => { setMondayPrice(e); clearValidationError("mondayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].mondayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Tuesday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={tuesdayPrice}
                                      onChange={(e: any) => { setTuesdayPrice(e); clearValidationError("tuesdayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].tuesdayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Wednesday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={wednesdayPrice}
                                      onChange={(e: any) => { setWednesdayPrice(e); clearValidationError("wednesdayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].wednesdayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Thursday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={thursdayPrice}
                                      onChange={(e: any) => { setThursdayPrice(e); clearValidationError("thursdayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].thursdayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Friday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={fridayPrice}
                                      onChange={(e: any) => { setFridayPrice(e); clearValidationError("fridayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].fridayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Saturday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={saturdayPrice}
                                      onChange={(e: any) => { setSaturdayPrice(e); clearValidationError("saturdayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].saturdayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 mb-3">
                                    <PriceInput
                                      labelClass="fs-6 form-label required"
                                      label={t("Sunday")}
                                      inputClass="form-control mb-0 border-right-0"
                                      placeholder={t("Price")}
                                      value={sundayPrice}
                                      onChange={(e: any) => { setSundayPrice(e); clearValidationError("sundayPrice"); }}
                                    />
                                    <div className='text-danger fw-bold'>{validationErrors[0].sundayPrice}</div>
                                  </div>
                                  <div className="col-lg-3 d-flex justify-content-center align-items-end">
                                    <button className='btn btn-primary mb-3' onClick={handleSave}>
                                      {editIndex > -1 ? t('Update') : t('Save')}
                                    </button>
                                  </div>
                                </div>
                                <div className="card">
                                  {/* begin::Body */}
                                  <div className='card-body pt-5 p-0'>
                                    {/* begin::Table container */}
                                    <div className='table-responsive'>
                                      {/* begin::Table */}
                                      <table className='table align-middle gs-0 gy-4'>
                                        {/* begin::Table head */}
                                        <thead>
                                          <tr className='fw-bold text-muted bg-light'>
                                            <th className='ps-4 min-w-325px rounded-start'>{t('Date Range')}</th>
                                            <th className='min-w-150px'>{t('Title')}</th>
                                            <th className='min-w-150px'>{t('Mon')}</th>
                                            <th className='min-w-150px'>{t('Tue')}</th>
                                            <th className='min-w-150px'>{t('Wed')}</th>
                                            <th className='min-w-150px'>{t('Thu')}</th>
                                            <th className='min-w-150px'>{t('Fri')}</th>
                                            <th className='min-w-150px'>{t('Sat')}</th>
                                            <th className='min-w-150px'>{t('Sun')}</th>
                                            <th className='min-w-200px rounded-end'>{t('Action')}</th>
                                          </tr>
                                        </thead>
                                        {/* end::Table head */}
                                        {/* begin::Table body */}
                                        <tbody>
                                          {
                                            specialPrice.map((item: any, index: any) => {
                                              return (
                                                <tr key={index}>
                                                  <td>
                                                    <div className='d-flex align-items-center'>
                                                      <div className='d-flex justify-content-start flex-column'>
                                                        <h6 className='fw-bold mb-1 fs-7'>
                                                          {formatDate(item.fromDate)} to {formatDate(item.toDate)}
                                                        </h6>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {
                                                        primLanguage == 'English' && item.en_title
                                                      }
                                                      {
                                                        primLanguage == 'Russian' && item.ru_title
                                                      }
                                                      {
                                                        primLanguage == 'Uzbek' && item.uz_title
                                                      }
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.mondayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.tuesdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.wednesdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.thursdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.fridayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.saturdayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <h6 className='fw-bold d-block mb-1 fs-7'>
                                                      {item.sundayPrice}
                                                    </h6>
                                                  </td>
                                                  <td>
                                                    <button
                                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                      onClick={() => handleEdit(index)}
                                                    >
                                                      <KTIcon iconName='pencil' className='fs-3' />
                                                    </button>
                                                    <button className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                                      onClick={() => handleRemove(index)}
                                                    >
                                                      <KTIcon iconName='trash' className='fs-3' />
                                                    </button>
                                                  </td>
                                                </tr>
                                              )
                                            })
                                          }
                                        </tbody>
                                        {/* end::Table body */}
                                      </table>
                                      {
                                        specialPrice.length == 0 && (
                                          <div className="row">
                                            <div className="col-lg-12 text-center">
                                              <label className="fs-6 text-gray-500 my-5 text-center">{t('No Records Found.')}</label>
                                            </div>
                                          </div>
                                        )
                                      }
                                      {/* end::Table */}
                                    </div>
                                    {/* end::Table container */}
                                  </div>
                                  {/* begin::Body */}
                                </div>
                                <div className="row">
                                  <div className="col-lg-12 mt-5">
                                    <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                      <button type='button' className='btn btn-light-primary me-4' onClick={handleClose}>{t('Cancel')}</button>
                                      <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToCarsPolicy}>
                                        <span className='indicator-label'>{t('Next')}</span>
                                        {loading && (
                                          <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                        )}
                                      </button>
                                      {' '}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content'>
                          <div className={clsx('tab-pane', { active: tab === 'Policy' })}>
                            <div className="dropzone border-success bg-light-success mb-2" id="kt_ecommerce_add_reject_reason">
                              <div className="d-flex">
                                <i className="fas fa-info-circle text-success fs-5 mt-1"></i>
                                <div className="ms-4 text-start">
                                  <span className="fs-7 fw-semibold text-gray-600">{t('“Note:  Indicate the total distance allowed during the tour or activity. Specify the distance in kilometers”')}</span>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12 my-3">
                                <label className="fs-3 fw-bolder form-label">{t('Mileage')}</label>
                              </div>
                              <div className="col-lg-12 my-2">
                                <label className="form-check form-check-inline form-check-solid me-5">
                                  <input className="form-check-input me-3" type="checkbox" name="isUnlimited" value="true" checked={isUnlimited} onChange={(e: any) => { handleIsUnlimited(e); removeError("isUnlimited"); }} />
                                  <span className="form-check-label d-flex flex-column align-items-start">
                                    <span className="fw-bold ps-2 fs-6 text-dark">{t('Unlimited')}</span>
                                  </span>
                                </label>
                              </div>
                            </div>
                            {
                              !isUnlimited && (
                                <div className="row">
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-4 form-label required">{t('Select Type (Day / Rental)')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <Select
                                      name='selectMileageType[]'
                                      id='mileageType'
                                      placeholder={t('Select Type')}
                                      isSearchable={true}
                                      options={mileageTypeList}
                                      value={mileageTypeSelectedOptions}
                                      onChange={(e: any) => { setMileageTypeSelectedOptions(e); removeError("mileageType") }}
                                    />
                                    {/* <!--end::Input--> */}
                                    <div className='text-danger fw-bold'>{error[0].mileageType}</div>
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Label--> */}
                                    <label className="fs-4 form-label required">{t('Mileage (KM)')}</label>
                                    {/* <!--end::Label--> */}
                                    {/* <!--begin::Input--> */}
                                    <input type="text" name="mileage" className="form-control mb-2" placeholder={t("Mileage")} value={mileage} onChange={(e) => { setMileage(e.target.value); removeError("mileage"); }} />
                                    <div className='text-danger fw-bold'>{error[0].mileage}</div>
                                  </div>
                                  <div className="col-lg-4 my-3">
                                    {/* <!--begin::Input--> */}
                                    <PriceInput
                                      labelClass="fs-5 form-label"
                                      label={t("If exceedes")}
                                      inputClass="form-control mb-2 border-right-0"
                                      placeholder={t("Price")}
                                      value={ifExceedes}
                                      onChange={(e: any) => { setIfExceedes(e); }}
                                    />
                                    {/* <!--end::Input--> */}
                                  </div>
                                </div>
                              )
                            }
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('BasicInfo')}>{t('Back')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={nextToCarsPhotos}>
                                    <span className='indicator-label'>{t('Next')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='tab-content pt-3'>
                          <div className={clsx('tab-pane', { active: tab === 'CarPhotos' })}>
                            <div className="row">
                              <div className="col-lg-12">
                                {/* <!--begin::Label--> */}
                                <label className="fs-5 form-label">{t('Upload images')}</label>
                                {/* <!--end::Label--> */}
                                <br />
                                <input
                                  ref={inputfileRef}
                                  style={{ display: 'none' }}
                                  className='modaldocument'
                                  type='file'
                                  onChange={handleImageChange}
                                  accept='image/*'
                                  multiple
                                />
                                <div className='d-flex flex-wrap align-items-center gap-3'>
                                  <span className='btn btn-light text-primary cursor-pointer ' onClick={handleTextClick}> {t('Attach Images')}</span>
                                  <ReorderButton reorder={reorder} />
                                </div>
                                <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                                <UploadedImageGrid
                                  reorder={reorder}
                                  images={uploadedImage}
                                  onRemove={handleRemoveImage}
                                />
                                <NewImageGrid
                                  reorder={reorder}
                                  files={inputImage}
                                  onRemove={handleRemove1}
                                />
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                            <div className="row">
                              <div className="col-lg-12">
                                <div className='d-flex flex-wrap justify-content-end pb-lg-0'>
                                  <button type='button' className='btn btn-light-primary me-4' onClick={() => setTab('Policy')}>{t('Back')}</button>
                                  <button type='button' disabled={disable} className='btn btn-primary me-4' onClick={() => { if (editVehicleId !== "") { editCarsApi(); } else { addCarsApi(); } }}>
                                    <span className='indicator-label'>{t('Submit')}</span>
                                    {loading && (
                                      <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                  </button>
                                  {' '}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!--end::Controls--> */}
                    </div>
                    {/* <!--end::Dropzone--> */}
                  </div>
                  {/* <!--end::Input group--> */}
                </div>
                {/* <!--end::Modal body--> */}
              </div>
              {/* <!--end::Form--> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export { ViewCarsList }
